import React, { useEffect, useRef, useState } from "react";
import "./DeleteModal.css";
import { Avatar, Box } from "@mui/material";
import Title from "../title/Title";
import {
  PrimaryButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import ModalCloseButton from "./ModalCloseButton";
import InviteUsers from "../../image/usersPlus.svg";
import TextInput from "../textInput/TextInput";
import Dropdown from "../dropdown/Dropdown";
import CustomPhoneInput from "../customPhoneInput/CustomPhoneInput";
import { isValidPhoneNumber } from "react-phone-number-input";
import DatePicker from "../datePicker/DatePicker";
import Checkbox from "../checkbox/Checkbox";
import Text from "../text/Text";
import AlightPermission from "./img/alightPermission.svg";
import ImageInput from "../imageInput/ImageInput";
import { getImageFirebase } from "../../config/utilities/getImageFirebase";
import { useAuth } from "../../config/utilities/useAuth";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 0,
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  overflow: "hidden",
  maxHeight: "95%",
};

export default function FamilyModal({
  isOpen,
  onClose,
  type,
  handleAddParent,
  handleAddChild,
  parentId,
  childId,
  setSelectedParentData,
  setSelectedChildData,
  selectedParentData = null,
  selectedChildData = null,
  handleUpdateParent,
  handleUpdateChild,
  onlyView,
}) {
  const { tripTypes } = useAuth();
  const [isMobileViewport, setIsMobileViewport] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  const generatePreferences = () => {
    const defaultTrips = {};
    (tripTypes || []).forEach((type) => {
      defaultTrips[type.id] = false;
    });

    const days = ["monday", "tuesday", "wednesday", "thursday", "friday"];
    const preferences = {};

    days.forEach((day) => {
      preferences[day] = { ...defaultTrips };
    });

    return preferences;
  };

  const preferenceOptions = [
    ...(tripTypes || [])
      .filter((type) => type.id !== "am")
      .map((type) => ({
        label: type.name,
        value: type.id,
      })),
    { label: "None", value: "none" },
  ];

  const [inputParent, setInputParent] = useState({
    firstName: "",
    lastName: "",
    preferredName: "",
    email: "",
    phoneNumber: "",
  });
  const [inputChild, setInputChild] = useState({
    firstName: "",
    lastName: "",
    preferredName: "",
    class: "",
    comment: "",
    alightPermission: false,
    childImg: "",
    grade: "",
    dob: "",
    note: "",
    preferences: generatePreferences(),
  });

  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [parentPreferredNameError, setParentPreferredNameError] =
    useState(false);
  const [childPreferredNameError, setChildPreferredNameError] = useState(false);
  const [noteError, setNoteError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [firstNameChildError, setFirstNameChildError] = useState(false);
  const [lastNameChildError, setLastNameChildError] = useState(false);
  const [classError, setClassError] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [gradeError, setGradeError] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [dateOfBirthError, setDateOfBirthError] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [keyUp, setKeyUp] = useState("", false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  const gradeOptions = [
    { label: "Primary", value: "PRIMARY" },
    { label: "Secondary", value: "SECONDARY" },
  ];
  const preferenceDays = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
  ];

  useEffect(() => {
    if (isOpen) {
      if (selectedParentData) {
        // Fill the input fields with selectedParentData
        setInputParent({
          firstName: selectedParentData.firstName,
          lastName: selectedParentData.lastName,
          preferredName: selectedParentData?.preferredName || "",
          email: selectedParentData.email,
          phoneNumber: selectedParentData.phoneNumber,
        });
      } else if (selectedChildData) {
        const defaultPreferences = generatePreferences();

        const mergedPreferences = { ...defaultPreferences };

        Object.keys(defaultPreferences).forEach((day) => {
          const fromApi = selectedChildData.preferences?.[day] || {};
          const mergedDay = {
            ...defaultPreferences[day],
            ...fromApi,
          };
          // Drop trip types removed from the institution so PM dropdowns match options (default None)
          mergedPreferences[day] = { am: mergedDay.am ?? false };
          (tripTypes || []).forEach((type) => {
            mergedPreferences[day][type.id] = mergedDay[type.id] ?? false;
          });
        });

        setInputChild({
          firstName: selectedChildData.firstName,
          lastName: selectedChildData.lastName,
          preferredName: selectedChildData?.preferredName || "",
          class: selectedChildData.class,
          comment: selectedChildData.comment || "",
          alightPermission: selectedChildData.alightPermission,
          childImg: selectedChildData.childImg,
          grade: selectedChildData.grade,
          dob: selectedChildData.dob,
          note: selectedChildData.note || "",
          preferences: mergedPreferences,
        });

        // Handle image loading if not base64
        if (
          selectedChildData.childImg &&
          !selectedChildData.childImg.startsWith("data:image")
        ) {
          getImageFirebase(selectedChildData.childImg)
            .then((url) => {
              setInputChild((prev) => ({ ...prev, childImg: url }));
            })
            .catch((error) => {
              console.error("Error fetching image from Firebase:", error);
            });
        }
      } else {
        // Reset for adding a new child
        setInputParent({
          firstName: "",
          lastName: "",
          preferredName: "",
          email: "",
          phoneNumber: "",
        });

        setInputChild({
          firstName: "",
          lastName: "",
          preferredName: "",
          class: "",
          comment: "",
          alightPermission: false,
          childImg: "",
          grade: "",
          dob: "",
          note: "",
          preferences: generatePreferences(),
        });
      }
    }
  }, [isOpen, selectedParentData, selectedChildData, tripTypes]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => observer.disconnect();
  }, [isOpen]);

  useEffect(() => {
    const handleResize = () => setIsMobileViewport(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle Image Upload
  const handleFileUpload = (base64Data) => {
    setInputChild((prev) => ({
      ...prev,
      childImg: base64Data, // Store new uploaded image as base64
    }));
  };

  // Handle input changes separately for parent and child
  const handleInputChange = (e, fieldName) => {
    if (typeof e === "string") {
      // Phone input case: directly update the field
      setInputParent((prev) => ({ ...prev, [fieldName]: e }));
    } else if (e?.target) {
      // Other input fields
      const { name, value } = e.target;
      if (type === "parent") {
        setInputParent((prev) => ({ ...prev, [name]: value }));
      } else {
        setInputChild((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const validateInputs = () => {
    let isValid = true;
    let isEmpty = false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setFirstNameError(false);
    setLastNameError(false);
    setEmailError(false);
    setPhoneNumberError(false);
    setGradeError(false);
    setFirstNameChildError(false);
    setLastNameChildError(false);
    setClassError(false);
    setCommentError(false);

    if (type === "parent") {
      const firstName = inputParent?.firstName || "";
      const lastName = inputParent?.lastName || "";
      const email = inputParent?.email || "";
      const phoneNumber = inputParent?.phoneNumber || "";

      isEmpty =
        !firstName.trim() || !lastName.trim() || !email.trim() || !phoneNumber;

      if (!firstName.trim()) {
        setFirstNameError(firstName.trim() ? true : false);
        isValid = false;
      }

      if (!lastName.trim()) {
        setLastNameError(lastName.trim() ? true : false);
        isValid = false;
      }

      if (!email.trim() || !emailRegex.test(email)) {
        setEmailError(email.trim() ? true : false);
        isValid = false;
      }

      if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) {
        setPhoneNumberError(phoneNumber ? true : false);
        isValid = false;
      }
    } else {
      const firstName = inputChild?.firstName || "";
      const lastName = inputChild?.lastName || "";
      const comment = inputChild?.comment || "";
      const alightPermission = inputChild?.alightPermission || false;

      isEmpty = !firstName.trim() || !lastName.trim();

      if (!firstName.trim()) {
        setFirstNameChildError(firstName.trim() ? true : false);
        isValid = false;
      }

      if (!lastName.trim()) {
        setLastNameChildError(lastName.trim() ? true : false);
        isValid = false;
      }

      // Validate comment only if alightPermission is true
      if (alightPermission && !comment.trim()) {
        setCommentError(comment.trim() ? true : false);
        isValid = false;
      }
    }
    setIsSubmitDisabled(isEmpty || !isValid);
  };

  // Run validation whenever inputs change
  useEffect(() => {
    validateInputs();
  }, [inputParent, inputChild]);

  const handleSubmit = () => {
    let newData;
    if (type === "parent") {
      newData = {
        id: selectedParentData ? selectedParentData.id : parentId,
        firstName: inputParent.firstName,
        lastName: inputParent.lastName,
        preferredName: inputParent.preferredName,
        email: inputParent.email,
        phoneNumber: inputParent.phoneNumber,
      };
      if (selectedParentData) {
        handleUpdateParent(newData);
        setSelectedParentData(null);
      } else {
        handleAddParent(newData);
        setSelectedChildData(null);
      }
    } else if (type === "child") {
      newData = {
        id: selectedChildData ? selectedChildData.id : childId,
        firstName: inputChild.firstName,
        lastName: inputChild.lastName,
        preferredName: inputChild.preferredName,
        grade: inputChild.grade,
        class: inputChild.class,
        alightPermission: inputChild.alightPermission || false,
        dob: inputChild.dob,
        note: inputChild.note,
        preferences: inputChild.preferences,
      };

      // Omit comment if alightPermission is false
      if (inputChild.alightPermission) {
        newData.comment = inputChild.comment || null;
      }

      // Omit childImg if it starts with the Firebase Storage URL
      if (
        !inputChild.childImg?.startsWith(
          "https://firebasestorage.googleapis.com"
        )
      ) {
        newData.childImg = inputChild.childImg;
      }

      if (selectedChildData) {
        handleUpdateChild(newData);
        setSelectedChildData(null);
      } else {
        handleAddChild(newData);
        setSelectedChildData(null);
      }
    }
    onClose();
  };

  const handleCheckboxChange = () => {
    setInputChild((prev) => ({
      ...prev,
      alightPermission: !prev.alightPermission,
    }));
  };

  const handlePreferencesChange = (day, selectedValue) => {
    if (selectedValue === "none") {
      const updated = {};
      tripTypes.forEach((type) => {
        if (type.id !== "am") updated[type.id] = false;
      });

      setInputChild((prev) => ({
        ...prev,
        preferences: {
          ...prev.preferences,
          [day]: {
            ...prev.preferences[day],
            ...updated,
          },
        },
      }));
    } else {
      const updated = {};
      tripTypes.forEach((type) => {
        if (type.id !== "am") {
          updated[type.id] = type.id === selectedValue;
        }
      });

      setInputChild((prev) => ({
        ...prev,
        preferences: {
          ...prev.preferences,
          [day]: {
            ...prev.preferences[day],
            ...updated,
          },
        },
      }));
    }
  };

  const toggleCheckboxPreference = (day, tripId) => {
    setInputChild((prev) => ({
      ...prev,
      preferences: {
        ...prev.preferences,
        [day]: {
          ...prev.preferences[day],
          [tripId]: !prev.preferences[day]?.[tripId],
        },
      },
    }));
  };

  const getPreferenceValue = (day) => {
    const prefs = inputChild.preferences?.[day];
    if (!prefs) return "none";

    const selected = Object.entries(prefs).find(
      ([key, value]) => key !== "am" && value === true
    );
    if (!selected) return "none";

    const selectedId = selected[0];
    const isValidPmType = tripTypes.some(
      (t) =>
        t.id !== "am" && String(t.id) === String(selectedId)
    );
    return isValidPmType ? selectedId : "none";
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <Box
        className="family-modal-box"
        sx={{
          ...style,
          width: {
            xs: "calc(100vw - 1.5rem)",
            sm: type === "parent" ? "26rem" : "65rem",
            md: type === "parent" ? "26rem" : "65rem",
          },
          maxHeight: { xs: "92vh", sm: "95%" },
        }}
      >
        <div className="user-modal-header">
          <div className="user-modal-header-contents">
            <div className="icon-button-container">
              <div className="icon-container">
                <img
                  style={{ margin: "auto" }}
                  src={InviteUsers}
                  alt="invite-users-icon"
                  loading="lazy"
                />
              </div>
              <div className="x-button-container">
                <ModalCloseButton onClick={onClose} className="user-x-button" />
              </div>
            </div>
            <div className="user-modal-header-title">
              <Title
                title={
                  type === "parent"
                    ? onlyView
                      ? "View Parent"
                      : selectedParentData
                      ? "Edit Parent"
                      : "Add Parent"
                    : onlyView
                    ? "View Child"
                    : selectedChildData
                    ? "Edit Child"
                    : "Add Child"
                }
                subtitle={`${
                  onlyView
                    ? "View"
                    : (type === "parent" && selectedParentData) ||
                      (type === "child" && selectedChildData)
                    ? "Edit"
                    : "Add"
                } ${onlyView ? "" : "a new"} ${type} ${
                  onlyView ? "in" : "to"
                } this BusBuddy family`}
                titleSize="1.125rem"
                subtitleSize="0.875rem"
                gap="0.25rem"
                lineHeight="1.75rem"
              />
            </div>
          </div>
        </div>
        <div
          ref={contentRef}
          className={`user-modal-content ${
            isOverflowing ? "has-overflow" : ""
          }`}
        >
          {type === "parent" ? (
            <>
              <div className="email-container">
                <div className="invite-text-input-container">
                  <TextInput
                    label="First Name"
                    placeholder={
                      onlyView ? inputParent.firstName : "Enter first name"
                    }
                    name="firstName"
                    type="text"
                    error={firstNameError}
                    setError={setFirstNameError}
                    onChangeFunction={handleInputChange}
                    width="22.9rem"
                    input={onlyView ? "" : inputParent}
                    setInput={setInputParent}
                    errorMessage="Enter valid name"
                    keyUp={keyUp}
                    setKeyUp={setKeyUp}
                    disable={onlyView}
                    required={true}
                  />
                </div>
              </div>
              <div className="email-container">
                <div className="invite-text-input-container">
                  <TextInput
                    label="Last Name"
                    placeholder={
                      onlyView ? inputParent.lastName : "Enter last name"
                    }
                    name="lastName"
                    type="text"
                    error={lastNameError}
                    setError={setLastNameError}
                    onChangeFunction={handleInputChange}
                    width="22.9rem"
                    input={onlyView ? "" : inputParent}
                    setInput={setInputParent}
                    errorMessage="Enter valid name"
                    keyUp={keyUp}
                    setKeyUp={setKeyUp}
                    disable={onlyView}
                    required={true}
                  />
                </div>
              </div>
              <div className="email-container">
                <div className="invite-text-input-container">
                  <TextInput
                    label="Preferred Name"
                    placeholder={
                      onlyView
                        ? inputParent.preferredName
                        : "Enter preferred name"
                    }
                    name="preferredName"
                    type="text"
                    error={parentPreferredNameError}
                    setError={setParentPreferredNameError}
                    onChangeFunction={handleInputChange}
                    width="22.9rem"
                    input={onlyView ? "" : inputParent}
                    setInput={setInputParent}
                    errorMessage="Enter valid name"
                    keyUp={keyUp}
                    setKeyUp={setKeyUp}
                    disable={onlyView}
                  />
                </div>
              </div>
              <div className="email-container">
                <div className="invite-text-input-container">
                  <TextInput
                    label="Email Address"
                    width="22.9rem"
                    placeholder={
                      onlyView || selectedParentData
                        ? inputParent.email
                        : "Enter email address"
                    }
                    name="email"
                    type="text"
                    error={emailError}
                    setError={setEmailError}
                    onChangeFunction={handleInputChange}
                    input={onlyView || selectedParentData ? "" : inputParent}
                    setInput={setInputParent}
                    errorMessage="Enter valid email address"
                    keyUp={keyUp}
                    setKeyUp={setKeyUp}
                    disable={onlyView || selectedParentData}
                    required={true}
                  />
                </div>
              </div>
              <div className="phone-container">
                <div className="input-container">
                  <CustomPhoneInput
                    disabled={onlyView}
                    label="Phone Number"
                    value={inputParent.phoneNumber || ""}
                    onChange={(value) =>
                      handleInputChange(value, "phoneNumber")
                    }
                    width={isMobileViewport ? "100%" : "22.9rem"}
                    error={phoneNumberError}
                    errorMessage="Enter valid phone number"
                    required={true}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="name-container">
                {!isMobileViewport && <div className="user-modal-text">Name</div>}
                <div className="invite-name-container child-name-grid">
                  <div className="input-container">
                    <TextInput
                      label="First Name"
                      placeholder={
                        onlyView ? inputChild.firstName : "Enter first name"
                      }
                      name="firstName"
                      type="text"
                      error={firstNameChildError}
                      setError={setFirstNameChildError}
                      onChangeFunction={handleInputChange}
                      width="100%"
                      input={onlyView ? "" : inputChild}
                      setInput={setInputChild}
                      errorMessage="Enter valid name"
                      keyUp={keyUp}
                      setKeyUp={setKeyUp}
                      disable={onlyView}
                      required={true}
                    />
                  </div>
                  <div className="input-container">
                    <TextInput
                      label="Last Name"
                      placeholder={
                        onlyView ? inputChild.lastName : "Enter last name"
                      }
                      name="lastName"
                      type="text"
                      error={lastNameChildError}
                      setError={setLastNameChildError}
                      onChangeFunction={handleInputChange}
                      width="100%"
                      input={onlyView ? "" : inputChild}
                      setInput={setInputChild}
                      errorMessage="Enter valid name"
                      keyUp={keyUp}
                      setKeyUp={setKeyUp}
                      disable={onlyView}
                      required={true}
                    />
                  </div>
                  <div className="input-container">
                    <TextInput
                      label="Preferred Name"
                      placeholder={
                        onlyView
                          ? inputChild.preferredName
                          : "Enter preferred name"
                      }
                      name="preferredName"
                      type="text"
                      error={childPreferredNameError}
                      setError={setChildPreferredNameError}
                      onChangeFunction={handleInputChange}
                      width="100%"
                      input={onlyView ? "" : inputChild}
                      setInput={setInputChild}
                      errorMessage="Enter valid name"
                      keyUp={keyUp}
                      setKeyUp={setKeyUp}
                      disable={onlyView}
                    />
                  </div>
                  <div className="child-image-container">
                    <Avatar
                      src={inputChild.childImg || undefined}
                      alt="Child Photo"
                      sx={{ width: "6rem", height: "6rem" }}
                    ></Avatar>
                    {isMobileViewport && (
                      <div className="mobile-child-photo-action">
                        <ImageInput
                          disable={onlyView}
                          onFileUpload={handleFileUpload}
                          label={
                            (type === "parent" && selectedParentData) ||
                            (type === "child" && selectedChildData)
                              ? "Change Photo"
                              : "Add Photo"
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="name-container">
                {!isMobileViewport && (
                  <div className="user-modal-text">Child Details</div>
                )}
                <div className="invite-name-container child-details-grid">
                  <div className="input-container">
                    <DatePicker
                      disable={onlyView}
                      label="Date of Birth"
                      placeholder="Enter date"
                      name="dob"
                      error={dateOfBirthError}
                      setError={setDateOfBirthError}
                      input={inputChild}
                      setInput={setInputChild}
                      errorMessage="Please select a valid date"
                      width="100%"
                    />
                  </div>
                  <div className="input-container">
                    <Dropdown
                      disabled={onlyView}
                      label="Grade"
                      options={gradeOptions}
                      name="grade"
                      placeholder="Enter grade"
                      error={gradeError}
                      onChangeFunction={handleInputChange}
                      input={inputChild}
                      width="100%"
                    />
                  </div>
                  <div className="input-container">
                    <TextInput
                      label="Class"
                      placeholder={onlyView ? inputChild.class : "Enter class"}
                      name="class"
                      type="text"
                      error={classError}
                      setError={setClassError}
                      onChangeFunction={handleInputChange}
                      width="100%"
                      input={onlyView ? "" : inputChild}
                      setInput={setInputChild}
                      errorMessage="Enter valid class"
                      keyUp={keyUp}
                      setKeyUp={setKeyUp}
                      disable={onlyView}
                    />
                  </div>
                  <div
                    className="image-input-container"
                    style={{ display: isMobileViewport ? "none" : "block" }}
                  >
                    <ImageInput
                      disable={onlyView}
                      onFileUpload={handleFileUpload}
                      label={
                        (type === "parent" && selectedParentData) ||
                        (type === "child" && selectedChildData)
                          ? "Change Photo"
                          : "Add Photo"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="name-container">
                <div className="user-modal-text">Permissions</div>
                <div className="invite-name-container">
                  <div className="alighting-container">
                    <div
                      className="alighting-input-container"
                      style={{
                        paddingBottom: inputChild.alightPermission
                          ? "0rem"
                          : "1rem",
                      }}
                    >
                      <div className="alighting-input-checkbox">
                        <div className="alighting-text">
                          <img
                            src={AlightPermission}
                            alt="invite-users-icon"
                            loading="lazy"
                          />
                          <Text
                            text={
                              isMobileViewport
                                ? "Walk Independently"
                                : "Consent to walk from stop independently"
                            }
                            size="0.875rem"
                            weight="500"
                            color="#344054"
                          />
                        </div>
                        <div className="alighting-checkbox">
                          <Checkbox
                            key="alightPermission"
                            checked={inputChild.alightPermission}
                            onChange={handleCheckboxChange}
                            text=""
                            width={isMobileViewport ? "20px" : "24px"}
                            height={isMobileViewport ? "20px" : "24px"}
                            disabled={onlyView}
                          />
                        </div>
                      </div>
                      {inputChild.alightPermission && (
                        <div style={{ width: "100%", marginBottom: "-0.5rem" }}>
                          <TextInput
                            placeholder={
                              onlyView ? inputChild.comment : "Add a comment"
                            }
                            name="comment"
                            type="text"
                            error={commentError}
                            setError={setCommentError}
                            onChangeFunction={handleInputChange}
                            width="100%"
                            input={onlyView ? "" : inputChild}
                            setInput={setInputChild}
                            errorMessage="Enter valid comment"
                            keyUp={keyUp}
                            setKeyUp={setKeyUp}
                            disable={onlyView}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="name-container" style={{ paddingTop: "2rem" }}>
                <div className="user-modal-text">Child Note</div>
                <div className="invite-name-container">
                  <div className="input-container">
                    <TextInput
                      placeholder={onlyView ? inputChild.note : "Enter note"}
                      name="note"
                      type="text"
                      error={noteError}
                      setError={setNoteError}
                      onChangeFunction={handleInputChange}
                      width="48rem"
                      input={onlyView ? "" : inputChild}
                      setInput={setInputChild}
                      errorMessage="Enter valid note"
                      keyUp={keyUp}
                      setKeyUp={setKeyUp}
                      disable={onlyView}
                    />
                  </div>
                </div>
              </div>
              <div className="name-container">
                <div className="user-modal-text">Preferences</div>
                <div className="invite-name-container">
                  {isMobileViewport ? (
                    <div className="mobile-preferences-container">
                      {preferenceDays.map((day) => (
                        <div key={day} className="mobile-preferences-row">
                          <div className="mobile-preferences-day">
                            {day.charAt(0).toUpperCase() + day.slice(1)}
                          </div>
                          <div className="mobile-preferences-controls">
                            <div className="mobile-preferences-am">
                              <Text
                                text="AM"
                                size="0.75rem"
                                weight="500"
                                color="#475467"
                              />
                              <Checkbox
                                checked={inputChild.preferences?.[day]?.am ?? false}
                                onChange={() =>
                                  toggleCheckboxPreference(day, "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                            <div className="mobile-preferences-pm">
                              <Dropdown
                                options={preferenceOptions}
                                name={`pm-${day}`}
                                value={getPreferenceValue(day)}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(day, e.target.value)
                                }
                                input={inputChild}
                                width="100%"
                                disabled={onlyView}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="preferences-container">
                    <table className="preferences-table">
                      <thead>
                        <tr>
                          <th style={{ borderRight: "1px solid #ddd" }}></th>
                          <th>Monday</th>
                          <th>Tuesday</th>
                          <th>Wednesday</th>
                          <th>Thursday</th>
                          <th>Friday</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th style={{ borderRight: "1px solid #ddd" }}>AM</th>
                          <td>
                            <div className="preferences-cell">
                              <Checkbox
                                checked={
                                  inputChild.preferences?.monday?.am ?? false
                                }
                                onChange={() =>
                                  toggleCheckboxPreference("monday", "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="preferences-cell">
                              <Checkbox
                                checked={
                                  inputChild.preferences?.tuesday?.am ?? false
                                }
                                onChange={() =>
                                  toggleCheckboxPreference("tuesday", "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="preferences-cell">
                              <Checkbox
                                checked={
                                  inputChild.preferences?.wednesday?.am ?? false
                                }
                                onChange={() =>
                                  toggleCheckboxPreference("wednesday", "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="preferences-cell">
                              <Checkbox
                                checked={
                                  inputChild.preferences?.thursday?.am ?? false
                                }
                                onChange={() =>
                                  toggleCheckboxPreference("thursday", "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="preferences-cell">
                              <Checkbox
                                checked={
                                  inputChild.preferences?.friday?.am ?? false
                                }
                                onChange={() =>
                                  toggleCheckboxPreference("friday", "am")
                                }
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th style={{ borderRight: "1px solid #ddd" }}>PM</th>
                          <td>
                            <div
                              className="preferences-cell"
                              style={{ paddingLeft: "0.3rem" }}
                            >
                              <Dropdown
                                options={preferenceOptions}
                                name="pmMonday"
                                value={getPreferenceValue("monday")}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(
                                    "monday",
                                    e.target.value
                                  )
                                }
                                input={inputChild}
                                width="6.1rem"
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              className="preferences-cell"
                              style={{ paddingLeft: "0.3rem" }}
                            >
                              <Dropdown
                                options={preferenceOptions}
                                name="pmTuesday"
                                value={getPreferenceValue("tuesday")}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(
                                    "tuesday",
                                    e.target.value
                                  )
                                }
                                input={inputChild}
                                width="6.1rem"
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              className="preferences-cell"
                              style={{ paddingLeft: "0.3rem" }}
                            >
                              <Dropdown
                                options={preferenceOptions}
                                name="pmWednesday"
                                value={getPreferenceValue("wednesday")}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(
                                    "wednesday",
                                    e.target.value
                                  )
                                }
                                input={inputChild}
                                width="6.1rem"
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              className="preferences-cell"
                              style={{ paddingLeft: "0.3rem" }}
                            >
                              <Dropdown
                                options={preferenceOptions}
                                name="pmThursday"
                                value={getPreferenceValue("thursday")}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(
                                    "thursday",
                                    e.target.value
                                  )
                                }
                                input={inputChild}
                                width="6.1rem"
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              className="preferences-cell"
                              style={{ paddingLeft: "0.3rem" }}
                            >
                              <Dropdown
                                options={preferenceOptions}
                                name="pmFriday"
                                value={getPreferenceValue("friday")}
                                onChangeFunction={(e) =>
                                  handlePreferencesChange(
                                    "friday",
                                    e.target.value
                                  )
                                }
                                input={inputChild}
                                width="6.1rem"
                                disabled={onlyView}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="button-container-invite">
          {onlyView ? (
            <SecondaryButton
              width="10rem"
              label="Cancel"
              imageIcon={false}
              onClickFunction={onClose}
            />
          ) : (
            <>
              <div
                className="child-buttons"
                style={{
                  marginTop: type === "parent" ? "0rem" : "3rem",
                }}
              >
                <SecondaryButton
                  width={type === "parent" ? "10rem" : "14rem"}
                  label="Cancel"
                  imageIcon={false}
                  onClickFunction={onClose}
                />
                <PrimaryButton
                  width={type === "parent" ? "10rem" : "14rem"}
                  label={
                    type === "parent"
                      ? selectedParentData
                        ? "Edit Parent"
                        : "Add Parent"
                      : selectedChildData
                      ? "Edit Child"
                      : "Add Child"
                  }
                  onClickFunction={handleSubmit}
                  disable={isSubmitDisabled}
                />
              </div>
            </>
          )}
        </div>
      </Box>
    </div>
  );
}
